import { GetParameterCommand, GetParameterCommandOutput, SSMClient } from '@aws-sdk/client-ssm';
import { ENVIRONMENT_VARIABLES } from 'src/constants/EnvironmentConstants';
import { CognitoService } from 'src/services/aws/CognitoService';

export class SSMService {
  private static client: SSMClient | null = null;
  private static cache: Map<string, Promise<string>> = new Map();

  private static getSSMClient(): SSMClient {
    if (this.client) return this.client;
    this.client = new SSMClient({
      region: ENVIRONMENT_VARIABLES.env.Region,
      credentials: CognitoService.credentialProvider
    });
    return this.client;
  }

  public static async retrieveParameter(parameterName: string): Promise<string> {
    const cached = this.cache.get(parameterName);
    if (cached) return cached;

    const promise = this.fetchParameter(parameterName).catch((error) => {
      this.cache.delete(parameterName);
      throw error;
    });
    this.cache.set(parameterName, promise);
    return promise;
  }

  private static async fetchParameter(parameterName: string): Promise<string> {
    const ssmClient = this.getSSMClient();
    const command = new GetParameterCommand({ Name: parameterName, WithDecryption: true });
    const response: GetParameterCommandOutput = await ssmClient.send(command);
    if (!response.Parameter?.Value) {
      throw new Error(`Unable to load parameter from AWS Systems Manager Parameter Store with key ${parameterName}`);
    }
    return response.Parameter.Value;
  }
}
